import React, { useState, useEffect, useCallback } from "react";
import { DashboardLayout } from "../components/layout";
import PostCard from "../components/feed/PostCard";
import CreatePostModal from "../components/post/CreatePostModal";
import api from "../services/api";

const HomePage = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  const fetchPosts = useCallback(async (p = 1, append = false) => {
    try { setLoading(true); const d = await api.getPosts(p, 10); if (append) setPosts(prev => [...prev, ...d.posts]); else setPosts(d.posts); setHasMore(p < d.totalPages); }
    catch (err) { console.error("Failed to load feed:", err); } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchPosts(1); }, [fetchPosts]);

  const loadMore = () => { const n = page + 1; setPage(n); fetchPosts(n, true); };
  const handlePostCreated = (p) => setPosts(prev => [p, ...prev]);
  const handlePostDelete = (id) => setPosts(prev => prev.filter(p => p.id !== id));

  return (
    <DashboardLayout onCreatePost={() => setShowCreate(true)}>
      <div
        className="flex-1 min-w-0 py-4 sm:py-6 px-4 sm:px-8 md:px-12 lg:px-[70px] overflow-y-auto"
        style={{ maxHeight: "calc(100vh - 56px)", scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <h1 className="text-[20px] sm:text-[24px] font-black text-gray-900 mb-4 sm:mb-5 tracking-tight font-body uppercase">Faith Feed</h1>
        {loading && posts.length === 0 ? (
          <div className="flex justify-center py-12"><div className="w-8 h-8 border-3 border-primary border-t-transparent rounded-full animate-spin" /></div>
        ) : posts.length === 0 ? (
          <div className="text-center py-16"><p className="text-gray-400 text-[15px] mb-4">No posts yet. Be the first to share!</p><button onClick={() => setShowCreate(true)} className="px-6 py-2.5 bg-primary text-white rounded-full text-[14px] font-semibold">Create Post</button></div>
        ) : (
          <>
            {posts.map(post => <PostCard key={post.id} post={post} onDelete={handlePostDelete} />)}
            {hasMore && <div className="text-center py-4"><button onClick={loadMore} disabled={loading} className="text-primary text-[14px] font-semibold hover:underline disabled:opacity-50">{loading ? "Loading..." : "Load more"}</button></div>}
          </>
        )}
      </div>
      <CreatePostModal isOpen={showCreate} onClose={() => setShowCreate(false)} onPostCreated={handlePostCreated} />
    </DashboardLayout>
  );
};

export default HomePage;
